module.exports = __webpack_public_path__ + "img/0.fcea9182.jpg";